import { inject, Injectable } from '@angular/core';
import { ChatbotResponseModel, ChatbotService as ChatbotBackendService } from '@pxl/shared/generated';
import { ChatbotService, ChatMessage, LoginService } from '@pxl/models/contracts';
import { Observable } from 'rxjs';
import { CONFIG_TOKEN } from '@pxl/models/common';

@Injectable()
export class DefaultChatbotService implements ChatbotService {
    private readonly chatbotBackendService = inject(ChatbotBackendService);
    private readonly config = inject(CONFIG_TOKEN);
    private readonly loginService = inject(LoginService);

    public initialize(): Observable<void> {
        return this.chatbotBackendService.initializeNewChat(this.config.API_VERSION, this.loginService.getToken());
    }
    public sendMessage(chatMessage: ChatMessage): Observable<ChatbotResponseModel> {
        return this.chatbotBackendService.sendChatMessage(chatMessage.message, this.config.API_VERSION, this.loginService.getToken());
    }

    public giveFeedback(chatbotConversationMessageId: string, wasHelpful: boolean): Observable<void> {
        return this.chatbotBackendService.giveFeedback(
            chatbotConversationMessageId,
            wasHelpful,
            this.config.API_VERSION,
            this.loginService.getToken(),
        );
    }
}
